export default __webpack_public_path__ + "static/media/A2_b.1fd0cc8f.png";